export default __webpack_public_path__ + "static/soraya-8e7a125e49731dab8c31fbc6ad1dfe5e.jpg";